/**
 *  Main navigation
 *
 *  @todo: Only enable on desktop.
 */

const doc = document;

if (doc.getElementById('block-sitetopmenu')) {

    const anchors = doc.getElementById('block-sitetopmenu').getElementsByTagName('a');
    const highlight = doc.getElementById('highlight');

    document.addEventListener("DOMContentLoaded", () => {
        highlight.style.left = `${anchors[0].offsetLeft}px`;
        highlight.style.opacity = 0;
    });

    for (let i = 0, len = anchors.length; i < len; i++) {
        anchors[i].addEventListener('mouseover', (e) => {
            const target = e.target;

            highlight.style.width = `${target.offsetWidth}px`;
            highlight.style.left = `${target.offsetLeft + 1}px`;
            highlight.style.opacity = 1;
        });

        anchors[i].addEventListener('mouseout', () => {
            highlight.style.opacity = 0;
            highlight.style.width = '0px';
        });
    }
}
